export default __webpack_public_path__ + "static/media/twelve-logo.fc2ca73a.svg";